/* stylelint-disable selector-class-pattern -- Global classes from react-aria */

.root {
    > [aria-roledescription="carousel"] {
        display: contents;
    }
}

.panels {
    display: block;
    overflow: auto hidden;
    scroll-snap-type: x mandatory;
    width: 100%;
}

.inner {
    white-space: nowrap;
}

.tabPanel {
    width: 100%;
    display: inline-block;
    white-space: initial;
    scroll-snap-align: start;
}

.tabList {
    --tab-dimension: var(--spacer-8);

    display: flex;
    gap: var(--spacer-8);
    place-self: end center;
    grid-row: container;
    grid-column: 1 / -1;
    translate: 0 calc(var(--spacer-24) + var(--tab-dimension));
}

.tab {
    width: var(--tab-dimension);
    height: var(--tab-dimension);
    border-radius: 50%;
    background: var(--color-contrast);

    &:not([aria-selected]) {
        opacity: 0.3;
    }
}

.controls {
    display: flex;
    z-index: 1;
    gap: var(--spacer-8);
}

.navArrow {
    svg {
        display: block;
        width: var(--spacer-40);
        height: var(--spacer-40);
        fill: var(--color-contrast);
    }

    &.previous svg {
        transform: scaleX(-1);
    }
}
